import * as types from '../types';
import commons from '../../util/commons';

export default {
  [types.SAVE_LOCALUSER]: (state, val) => {
    if (val.bool) {
      state.localUser = commons.readTodos('localUser');
    } else {
      state.localUser = null;
    }
  },
  [types.SAVE_HOMEDATA]: (state, val) => {
    state.homedata = val;
  },
  [types.SAVE_LOCALCART]: (state, val) => {
    if (val.bool && state.localUser) {
      state.localCart = commons.readTodos('localCart' + state.localUser.user);
    } else {
      state.localCart = null;
    }
  },
  // 初始化
  [types.INIT_LOCALCART]: (state, val) => {
    if(state.localUser){
      state.localCart = commons.readTodos('localCart' + state.localUser.user);
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/asset/mutations.js